export enum Flags {
    BILLING_NOTIFICATION_ENABLED_PRODUCTS = "billing_notification_enabled_products",
    DISABLE_CUSTOM_ROLE_CREATION = "disable_custom_role_creation",
    ENABLE_ACTIVITY_LOG = "enable_activity_log",
    ENABLE_ACCESS_MANAGEMENT = "enable_access_management",
    ENABLE_FORETHOUGHT_WIDGET = "enable_forethought_widget",
    ENABLE_BATCH_USER_DELETION = "enable_batch_user_deletion",
    ENABLE_BILLING_NOTIFICATION_SETTINGS = "enable_billing_notifications",
    ENABLE_BREADCRUMBS = "enable_breadcrumbs",
    ENABLE_DETAILED_BREADCRUMBS = "enable_detailed_breadcrumbs",
    ENABLE_BULK_DISPLAY = "enable_bulk_display",
    ENABLE_BULK_UPLOAD = "enable_bulk_upload",
    ENABLE_BULK_UPLOAD_ACCESS = "enable_bulk_upload_access",
    ENABLE_CUSTOM_NAVIGATION_URL = "enable_custom_navigation_url",
    ENABLE_DEVELOPER_SETTINGS = "enable_developer_settings",
    // Gates direct-region (EU data residency) authentication. Resolved pre-auth against
    // the CONSTANT bucketing id "anonymous" (see euFeatureFlag), because no profile
    // exists yet. Every visitor therefore lands in the same bucket, so a percentage
    // rollout would not split traffic at all — it would resolve all-on or all-off for
    // everyone, at whichever side of the line that one id falls. Run it at 100% or 0%
    // only, and treat any intermediate value as meaningless rather than gradual.
    ENABLE_EU = "enable_eu",
    ENABLE_EXTERNAL_USER_STATUS_DISPLAY = "enable_external_user_status_display",
    ENABLE_GEN_AI = "enable_genai_settings",
    ENABLE_GRANULAR_GROUP_FILTERS = "enable_granular_group_filters",
    ENABLE_GROUP_ACCESS_FLOW = "enable_group_access_flow",
    ENABLE_INSTANCE_PERMISSIONS_TAB = "enable_instance_permissions_tab",
    ENABLE_INVITATION_FLOW = "enable_invitation_flow",
    ENABLE_INVITATION_STEPS = "enable_invitation_steps",
    ENABLE_MASTER_DASHBOARD = "enable_master_dashboard",
    ENABLE_MULTISELECT_GROUP_TYPE_FILTERS = "enable_multi_select_group_type_filter",
    ENABLE_NAVIGATION_TOOLTIPS = "enable_navigation_tooltips",
    ENABLE_OPAL_AUTO_PROVISIONING = "enable_opal_auto_provisioning",
    ENABLE_OPAL_REMOVAL_ALERT = "enable_opal_removal_alert",
    ENABLE_SAVE_GROUP_FILTER_SELECTION = "enable_save_group_filter_selection",
    ENABLE_SCIM_TEAMS = "enable_scim_teams",
    ENABLE_SUPPORT_FEATURES = "enable_support_features",
    ENABLE_TEAM_GROUPS = "enable_team_groups",
    FILTER_GROUPS_AND_ROLES_PER_ENTITLEMENTS = "filter_groups_and_roles_per_entitlements",
    HIDE_FORCE_ACCEPTANCE_CHECKBOX = "hide_force_acceptance_checkbox",
    HIDE_PRODUCT_GROUPS = "hide_product_groups",
    HIDE_SUPPORT_ORGANIZATIONS = "hide_support_organizations",
    SHOW_EXTERNAL_USER_STATUS_COLUMN = "show_external_user_status_column",
    SHOW_USER_GROUP_OWNER_COLUMN_FLAG = "show_user_group_owner_column",
    SHOW_USER_GROUP_USER_COUNT_COLUMN_FLAG = "show_user_group_user_count_column",
    SHOW_ROLES = "show_roles",
    SHOW_ROLES_SIDEBAR_NAVIGATION = "enable_roles_sidebar_navigation",
    SHOW_INVITATIONS = "show_invitations",
    SHOW_LOGIN_STATUS = "show_login_status",
    SHOW_OPTI_ID_BADGE = "show_opti_id_badge",
    SHOW_SUPPORT_USAGE_TAB = "support_page_usage_and_billing_tab",
    SHOW_USAGE_AND_BILLING = "show_usage_and_billing",
    SHOW_USER_ACTIVATION_STATUS = "show_user_activation_status",
    USE_ATTRIBUTE_PERMISSIONS = "use_attribute_based_permissions",
    SUPPORT_PAGE_UPDATES = "support_page_updates",
    INSTANCE_USER_MANAGER_UPDATES = "instance_user_manager_updates",
    ENABLE_COOKIELESS_EMBEDDING = "enable_cookieless_embedding",
    SSO_SUPPORTED_LOCAL_LOGIN = "sso_supported_local_login",
    ENABLE_CMP_ROLE_ENHANCEMENT = "enable_cmp_role_enhancement",
    RESTRICTED_SUPPORT_ORGS = "restrict_to_support_only",
    ENABLE_SCIM_UI = "enable_scim_ui",
    ENABLE_USERS_DEFAULT_LANDING_PAGE = "enable_users_default_landing_page",
    SHOW_SIDE_NAVIGATION_GROUPINGS = "show_side_navigation_groupings",
    USE_SUPPORTS_TEAMS_PROPERTY = "use_supports_teams_property",
    ENABLE_REBRAND = "enable_rebrand",
    ENABLE_VIRTUAL_AGENT_USERS = "enable_virtual_agent_users",
    RENAME_OPAL = "rename_opal"
}
